// ─── ALPINE.JS SEARCH COMPONENT ───────────────────────────────────────────────
// Requiere storefront-search-api.js cargado antes en el template

document.addEventListener('alpine:init', () => {
  Alpine.data('storefrontSearch', (config = {}) => ({

    initialized: false,

    // ── Config desde Liquid via x-data ────────────────────────────────────
    targetMarket: config.targetMarket || 'rest',  // 'es_pt' | 'it_fr_ea_int' | 'en' | 'rest'
    typeOrder:    config.typeOrder    || [],       // array del metaobject search-group-order-config
    priorityTag:  config.priorityTag  || 'MariaGdeJaime',

    // ── Estado de búsqueda ─────────────────────────────────────────────────
    query: (() => {
      const params = new URLSearchParams(window.location.search);
      const raw = params.get('q') || '';
      return raw.split(' tag:')[0].replace(/\*/g, '').trim();
    })(),
    products:    [],
    renderedIds: new Set(),
    totalCount:  0,
    hasNextPage: false,
    endCursor:   null,

    // ── Estado de carga ────────────────────────────────────────────────────
    loading:     false,  // carga inicial / nueva búsqueda
    loadingMore: false,  // carga de página siguiente (infinite scroll)

    // ── Filtros activos (leídos de la URL al init) ─────────────────────────
    activeFilters: [],   // array en formato productFilters para la API

    // ── Ordenación (leída de la URL al init) ──────────────────────────────
    sortKey: 'RELEVANCE',
    reverse: false,

    // ── Debounce ───────────────────────────────────────────────────────────
    _debounceTimer: null,

    // ── Filtros que devuelve la API ───────────────────────────────────────────────────────────
    availableFilters: [],

    // ── Ordenación (UI) ───────────────────────────────────────────────────
    sort: 'relevance',

    // ── Filtros para el priceFilter ──────────────────────────────────
    priceFilterMin:      0,
    priceFilterMax:      1000,
    priceFilterRangeMax: null,

    // ── Filtros activos por facet ──────────────────────────────────
    activeFilterMap: {},

    // ──────────────────────────────────────────────────────────────────────
    // INIT — se ejecuta cuando Alpine monta el componente
    // ──────────────────────────────────────────────────────────────────────
    async init() {
      // Carga los colores
      await loadColorMap();

      // Leer query de la URL (quitando el tag de universo si lo hay)
      const params     = new URLSearchParams(window.location.search);
      const isInescop  = params.get('type') === 'inescop';
      const hasFilters = [...params.keys()].some(k => k.startsWith('filter.'));
      const rawQuery   = params.get('q') || '';
      this.query       = rawQuery.split(' tag:')[0].replace(/\*/g, '').trim();

      // Si no hay query ni universo, no lanzar búsqueda — mostrar bestsellers
      if (this.query.length === 0 && !this.universe_tag_active && !isInescop && !hasFilters) {
        return;
      }

      // Leer filtros activos de la URL y convertirlos al formato de la API
      const { filters, state } = SearchAPI.readFiltersFromURL(this.targetMarket);
      this.activeFilters = filters;

      // Restaurar sort
      const sort   = SearchAPI.getSortFromURL();
      this.sortKey = sort.sortKey;
      this.reverse = sort.reverse;
      this.sort    = params.get('sort_by') || 'RELEVANCE';

      // Búsqueda inicial
      await this.search(false);

      // Ahora que tenemos availableFilters, reconstruir activeFilterMap desde la URL
      this._restoreFilterMapFromURL(params);

      // Arrancar infinite scroll
      this._setupObserver();

      this.initialized = true;
    },

    // ──────────────────────────────────────────────────────────────────────
    // BÚSQUEDA
    // ──────────────────────────────────────────────────────────────────────
    async search(append = false) {
      if (this.loading || this.loadingMore) return;

      if (!append) {
        this.loading     = true;
        this.products    = [];
        this.renderedIds = new Set();
        this.endCursor   = null;
        this.hasNextPage = false;
      } else {
        this.loadingMore = true;
      }

      try {
        // Construir query con universo si aplica
        const params      = new URLSearchParams(window.location.search);
        const rawQuery    = params.get('q') || '';
        const universeTag = rawQuery.includes(' tag:')
        ? rawQuery.split(' tag:')[1]
        : '';

        let apiQuery = this.query.trim() || '*';
        if (universeTag) apiQuery += ` tag:${universeTag}`;

        const result = await SearchAPI.searchProducts({
          query:   apiQuery,
          first:   24,
          after:   append ? this.endCursor : null,
          filters: this.activeFilters,
          sortKey: this.sortKey,
          reverse: this.reverse,
          country:  window.__STOREFRONT_COUNTRY__  || 'ES',
          language: window.__STOREFRONT_LANGUAGE__ || 'ES',
        });

        // ── Deduplicar ────────────────────────────────────────────────────
        const newProducts = result.products.filter(p => !this.renderedIds.has(p.id));
        newProducts.forEach(p => this.renderedIds.add(p.id));

        // Se prdena por tipo cuando no se pide el orden mediante el filtro search-storefront-facet-sort.liquid
        const ordered = this.sortKey === 'RELEVANCE'
          ? (() => {
            const sorted   = SearchAPI.sortProductsByTypeOrder(newProducts, this.typeOrder);
            const priority = sorted.filter(p =>  p.tags.includes(this.priorityTag));
            const rest     = sorted.filter(p => !p.tags.includes(this.priorityTag));
            return [...priority, ...rest];
           
          })()
          : newProducts;

        this.products    = append ? [...this.products, ...ordered] : ordered;
        this.totalCount  = result.totalCount;
        this.hasNextPage = result.hasNextPage;
        this.endCursor   = result.endCursor;

        //Para búsquedas nuevas
        if (!append) {
          this.availableFilters = result.productFilters;

          // Inicializar rango de precio
          const priceFilter = result.productFilters.find(f => f.id === 'filter.v.price');
          
          if (priceFilter && !this.priceFilterRangeMax) {
            const maxPrice = priceFilter.values?.[0]?.input
            ? JSON.parse(priceFilter.values[0].input)?.price?.max || 1000
            : 1000;
            this.priceFilterRangeMax = Math.round(maxPrice * 100);
            this.priceFilterMax = this.priceFilterRangeMax;
          }

          // Para leer los inescop-types
          const inescop = result.productFilters.find(f => f.id === 'filter.p.m.custom.ficha_asociada');
          Alpine.store('searchStorefrontAPI').inescop = inescop || null;
        }

      } catch (err) {
        console.error('[storefront-search] error:', err);
      } finally {
        this.loading     = false;
        this.loadingMore = false;
      }
    },

    // ──────────────────────────────────────────────────────────────────────
    // INPUT CON DEBOUNCE - AUTOMATIC SEARCH
    // ──────────────────────────────────────────────────────────────────────
    onQueryInput() {
      clearTimeout(this._debounceTimer);

      // Sincronizar con $store para los snippets de universos e inescop
      if (Alpine.store('search')) {
          Alpine.store('search').query = this.query;
      }

      if (this.query.length === 0) {
        // Sin query → redirigir a la URL limpia para que Liquid pinte best sellers
        this._updateURL();
        return;
      }

      if (this.query.length < 2) return;

      this._debounceTimer = setTimeout(() => {
        // Actualizar URL sin recargar para mantener el historial
        this._updateURL();
        this.search(false);
      }, 300);
    },

    onSortChange() {
      const map = {
          'relevance':  { sortKey: 'RELEVANCE', reverse: false },
          'price-asc':  { sortKey: 'PRICE',     reverse: false },
          'price-desc': { sortKey: 'PRICE',     reverse: true  },
      };
      const s = map[this.sort] || map['relevance'];
      this.sortKey = s.sortKey;
      this.reverse = s.reverse;
      this._updateURL();
      this.search(false);
    },

    get universe_tag_active() {
      const params = new URLSearchParams(window.location.search);
      const raw = params.get('q') || '';
      const isInescop = params.get('type') === 'inescop';
      const hasFilter = [...params.keys()].some(k => k.startsWith('filter.'));
      return raw.includes(' tag:') || isInescop || hasFilter;
    },

    clearFilters() {
      this.activeFilterMap = {};
      this.activeFilters   = [];
      this.priceFilterMin  = 0;
      this.priceFilterMax  = this.priceFilterRangeMax;
      this.sortKey         = 'RELEVANCE';
      this.reverse         = false;
      this._updateURL();
      this.search(false);
    },

    toggleSearchFilter(filterId, value) {
      if (!this.activeFilterMap[filterId]) {
        this.activeFilterMap[filterId] = [];
      }
      const idx = this.activeFilterMap[filterId].indexOf(value.id);
      if (idx === -1) {
        this.activeFilterMap[filterId].push(value.id);
      } else {
        this.activeFilterMap[filterId].splice(idx, 1);
      }
      this._rebuildActiveFilters();
    },

    isFilterActive(filterId, valueId) {
      return (this.activeFilterMap[filterId] || []).includes(valueId);
    },

    toggleAllSearchFilter(filter) {
      const allActive = filter.values.every(v => this.isFilterActive(filter.id, v.id));
      if (allActive) {
        this.activeFilterMap[filter.id] = [];
      } else {
        this.activeFilterMap[filter.id] = filter.values.map(v => v.id);
      }
      this._rebuildActiveFilters();
    },

    isAllFilterActive(filter) {
      return filter.values.length > 0 &&
        filter.values.every(v => this.isFilterActive(filter.id, v.id));
    },

    applyPriceFilter(min, max) {
      this.priceFilterMin = min;
      this.priceFilterMax = max;
      const priceFilter = { price: {} };
      if (min > 0)                        priceFilter.price.min = min / 100;
      if (max < this.priceFilterRangeMax) priceFilter.price.max = max / 100;

      // Si no hay rango real activo, eliminar el filtro de precio
      const hasPriceFilter = Object.keys(priceFilter.price).length > 0;
      this.activeFilters = [
        ...this.activeFilters.filter(f => !f.price),
        ...(hasPriceFilter ? [priceFilter] : []),
      ];

      this._updateURL();
      this.search(false);
    },

    setSortAndSearch(value) {
      this.sort = value;
      this.onSortChange();
    },

    // Whitelist de filtros que son aceptados (para que no muestre un filtro por cada dto_ en todos los markets)
    isValidFilter(filterId) {
      return [
        'filter.p.m.custom.color',
        'filter.v.option.size',
        'filter.p.product_type',
        'filter.v.price',
        `filter.p.m.custom.dto_${this.targetMarket}`,
        'filter.p.m.custom.ficha_asociada'
      ].includes(filterId);
    },

    _rebuildActiveFilters() {
      const filters = [];

      // Guardar el filtro de precio si está activo
      if (this.priceFilterMin > 0 || this.priceFilterMax < this.priceFilterRangeMax) {
        const priceFilter = { price: {} };
        if (this.priceFilterMin > 0) priceFilter.price.min = this.priceFilterMin / 100;
        if (this.priceFilterMax < this.priceFilterRangeMax) priceFilter.price.max = this.priceFilterMax / 100;
        filters.push(priceFilter);
      }

      for (const [filterId, valueIds] of Object.entries(this.activeFilterMap)) {
          for (const valueId of valueIds) {
          // Buscar el input del value en availableFilters
          const facet = this.availableFilters.find(f => f.id === filterId);
          const value = facet?.values.find(v => v.id === valueId);
          if (value?.input) {
              filters.push(JSON.parse(value.input));
          }
          }
      }
      this.activeFilters = filters;
      this._updateURL();
      this.search(false);
    },

    getFilterLabel(filterId, valueId) {
      const facet = this.availableFilters.find(f => f.id === filterId);
      return facet?.values.find(v => v.id === valueId)?.label || valueId;
    },

    getFilterValue(filterId, valueId) {
      const facet = this.availableFilters.find(f => f.id === filterId);
      return facet?.values.find(v => v.id === valueId);
    },

    // ──────────────────────────────────────────────────────────────────────
    // INFINITE SCROLL
    // ──────────────────────────────────────────────────────────────────────
    _setupObserver() {
      this.$nextTick(() => {
        const sentinel = this.$refs.sentinel;
        if (!sentinel) return;

        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.hasNextPage && !this.loadingMore && !this.loading) {
              this.search(true);
            }
          });
        }, { rootMargin: '400px 0px', threshold: 0 });

        observer.observe(sentinel);
      });
    },

    // ──────────────────────────────────────────────────────────────────────
    // HELPERS
    // ──────────────────────────────────────────────────────────────────────

    _updateURL() {
      const url    = new URL(window.location.href);
      const params = new URLSearchParams(window.location.search);
      const raw    = params.get('q') || '';
      const tag    = raw.includes(' tag:') ? raw.split(' tag:')[1] : '';
      
      // Query
      let q        = this.query.trim() || '*';
      if (tag) q  += ` tag:${tag}`;
      url.searchParams.set('q', q);

      // Limpiar filtros anteriores a la URL
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.')) url.searchParams.delete(key);
      }

      // Serializar activeFilterMap -> params de Shopify
      for (const [filterId, valueIds] of Object.entries(this.activeFilterMap)) {
        for (const valueId of valueIds) {
          const facet = this.availableFilters.find(f => f.id === filterId);
          const value = facet?.values.find(v => v.id === valueId);
          if (!value?.input) continue;

          const input = JSON.parse(value.input);

          // Color (filter.p.m.custom.color y filter.p.m.custom.dto_XXXXXX)
          if (input.productMetafield) {
            const key = `filter.p.m.custom.${input.productMetafield.key}`;
            url.searchParams.append(key, input.productMetafield.value);
          }

          // Talla (filter.v.option.size)
          else if (input.variantOption) {
            url.searchParams.append(`filter.v.option.${input.variantOption.name}`, input.variantOption.value);
          }

          // Tipo de producto (filter.p.product_type)
          else if (input.productType) {
            url.searchParams.append('filter.p.product_type', input.productType);
          }
        }
      }

      // Precio
      if (this.priceFilterMin > 0) {
        url.searchParams.set('filter.p.price.gte', (this.priceFilterMin / 100).toFixed(2));
      }
      if (this.priceFilterMax < this.priceFilterRangeMax) {
        url.searchParams.set('filter.p.price.lte', (this.priceFilterMax / 100).toFixed(2));
      }

      // Orden
      if (this.sort !== 'RELEVANCE') {
        url.searchParams.set('sort_by', this.sort);
      } else {
        url.searchParams.delete('sort_by');
      }

      history.replaceState(null, '', url.toString());
    },


    _restoreFilterMapFromURL(params) {
      const map = {};

      for (const [key, value] of params.entries()) {
        if (!key.startsWith('filter.') || key.startsWith('filter.p.price')) continue;

        // Buscar el filtro en availableFilters que tenga un input que matchee
        for (const facet of this.availableFilters) {
          for (const v of facet.values) {
            if (!v.input) continue;

            const input = JSON.parse(v.input);

            const matches =
              (input.productMetafield && key === `filter.p.m.custom.${input.productMetafield.key}` && value === input.productMetafield.value) ||
              (input.variantOption    && key === `filter.v.option.${input.variantOption.name}`      && value === input.variantOption.value)    ||
              (input.productType      && key === 'filter.p.product_type'                             && value === input.productType);

            if (matches) {
              if (!map[facet.id]) map[facet.id] = [];
              if (!map[facet.id].includes(v.id)) map[facet.id].push(v.id);
            }
          }
        }
      }

      this.activeFilterMap = map;

      // Precio
      const gte = params.get('filter.p.price.gte');
      const lte = params.get('filter.p.price.lte');
      if (gte) this.priceFilterMin = Math.round(parseFloat(gte) * 100);
      if (lte) this.priceFilterMax = Math.round(parseFloat(lte) * 100);
    }
  }));
});

// ─── HELPERS GLOBALES PARA LAS CARDS ─────────────────────────────────────────
// Las cards viven en su propio x-data anidado y no tienen acceso a los métodos
// del componente padre storefrontSearch, así que las exponemos globalmente.

// Inyecta las variantes en window.__variants_sf para el add to cart
window.injectVariants = function(product) {
  if (!window.__variants_sf) window.__variants_sf = {};
  if (window.__variants_sf[product.id]) return;
  const map = {};
  (product.variants?.edges || []).forEach(({ node }) => {
    map[node.id] = {
      id:        node.id,
      title:     node.title,
      available: node.availableForSale,
      barcode:   node.barcode || null,
      sku:       node.sku    || null,
    };
  });
  window.__variants_sf[product.id] = map;
};

// Variantes del producto
window.getFirstVariant = function(product) {
  const edges = product.variants?.edges || [];
  if (edges.length === 1) return edges[0].node.id;
  return null;
};

window.getFirstVariantAvailable = function(product) {
  const edges = product.variants?.edges || [];
  if (edges.length === 1) return edges[0].node.availableForSale;
  return null;
};

window.getVariants = function(product) {
  return (product.variants?.edges || []).map(e => e.node);
};

window.getColorObject = function(product) {
  const mf = product.metafields?.find(m => m?.key === 'color');
  if (!mf?.reference?.fields) return null;
  const f = mf.reference.fields;
  return {
    label:    f.find(x => x.key === 'label')?.value    || '',
    color:    f.find(x => x.key === 'color')?.value    || '',
    imageUrl: f.find(x => x.key === 'image')?.reference?.image?.url || null,
  };
};

window.getColorStyle = function(product) {
  const c = window.getColorObject(product);
  if (!c) return '';
  let style = '';
  if (c.color)    style += `background-color: ${c.color};`;
  if (c.imageUrl) style += `background-image: url(${c.imageUrl});`;
  return style;
};

window.getColorLabel = function(product) {
  return window.getColorObject(product)?.label || '';
};

window.getDiscountBadge = function(product) {
  const compareAtPrice = parseFloat(product.compareAtPriceRange?.minVariantPrice?.amount || 0);
  const price   = parseFloat(product.priceRange?.minVariantPrice?.amount || 0);
  if (compareAtPrice <= price) return null;
  let pct = Math.floor((compareAtPrice - price) * 100 / compareAtPrice);
  const hasFW25     = product.tags?.includes('FW25');
  const hasBarefoot = product.tags?.includes('Barefoot') || product.tags?.includes('barefoot');
  if (hasFW25 && !hasBarefoot && pct <= 20) pct = 20;
  return `-${pct}%`;
};

window.getBarefootInescop = function(product) {
  const mf = product.metafields?.find(m => m?.key === 'barefoot_inescop');
  return mf?.value && mf.value !== '';
};

window.getImageBg = function(product) {
  const img = product.featuredImage;
  if (!img?.width || !img?.height) return 'bg-[#F8F4F1]';
  const ar = img.width / img.height;
  return (ar > 0.85 && ar <= 1.2) ? 'bg-white' : 'bg-[#F8F4F1]';
};

window.getRelatedProducts = function(product) {
  const mf = product.metafields?.find(m => m?.key === 'related_products');
  if (!mf?.references?.edges) return [];
  const refs  = mf.references.edges.map(e => e.node).filter(p => p.availableForSale);
  const hasMe = refs.some(p => p.id === product.id);
  const list  = hasMe ? refs : [product, ...refs];
  return list.sort((a, b) => a.handle.localeCompare(b.handle));
};

// Precio formateado
window.formatPrice = function(amount, currency) {
  const cur = currency || window.__STOREFRONT_CURRENCY__ || 'EUR';
  return new Intl.NumberFormat('es-ES', {
    style:    'currency',
    currency: cur,
  }).format(parseFloat(amount));
};

// URL del producto con prefijo de market
window.productURL = function(handle) {
  const prefix = window.__MARKET_PREFIX__ || '';
  return `${prefix}/products/${handle}`;
};

// Estilo del color
window.getSearchColorStyle = function(value) {
  const groupMap = window.__COLOR_GROUP_MAP__ || {};
  const colorMap = window.__COLOR_MAP__ || {};
  const c = groupMap[value.label] || colorMap[value.label];
  if (!c) return '';
  let style = '';
  if (c.color)    style += `background-color: ${c.color};`;
  if (c.imageUrl) style += `background-image: url(${c.imageUrl});`;
  return style
};

// Label del descuento
window.getDiscountLabel = function(label) {
  const map = {
    '10':  '≤ 10%',
    '20':  '11% – 20%',
    '30':  '21% – 30%',
    '40':  '31% – 40%',
    '50':  '41% – 50%',
    '50plus': '> 50%',
  };
  return map[label] || label;
};

// Label del tipo de producto
window.getProductTypeLabel = function(value) {
  return (window.__PRODUCT_TYPE_LABELS__ || {})[value] || value;
};